<template>
    <div
        v-show="open"
        class="fixed inset-x-0 bottom-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
    >
        <transition
            enter-active-class="transition duration-300 ease-out transform"
            enter-class="opacity-0 "
            enter-to-class="opacity-100 "
            leave-active-class="transition duration-200 ease-in transform"
            leave-class="opacity-100 "
            leave-to-class="opacity-0"
            v-show="open"
        >
            <div class="fixed inset-0 transition-opacity">
                <div
                    @click="$emit('modal-close')"
                    class="absolute inset-0 bg-gray-500 opacity-75"
                ></div>
            </div>
        </transition>
        <transition
            enter-active-class="transition duration-300 ease-out transform"
            enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
            enter-to-class="translate-y-0 opacity-100 sm:scale-100"
            leave-active-class="transition duration-200 transform"
            leave-class="translate-y-0 opacity-100 sm:scale-100"
            leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
            v-show="open"
        >
            <div
                class="px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-4xl sm:w-full sm:p-6"
            >
                <div>
                    <!-- <div
            class="flex items-center justify-center inline-block w-20 h-20 mx-auto overflow-hidden bg-gray-100 rounded-full"
          >
            <svg
              fill="currentColor"
              viewBox="0 0 24 24"
              class="w-full h-full text-gray-300"
            >
              <path
                d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
              ></path>
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Payment
              successfulsssssssssssssssssssssssssssssssssssssssssssssssssssssssssss
            </h3>
            <div class="mt-2">
              <p class="text-sm leading-5 text-gray-500"></p>
            </div>
          </div> -->

                    <div
                        v-if="loading"
                        class="overflow-hidden bg-white shadow sm:rounded-lg h-96"
                    ></div>

                    <div
                        v-if="!loading"
                        class="overflow-hidden bg-white shadow sm:rounded-lg"
                    >
                        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
                            <h3
                                class="text-lg font-medium leading-6 text-gray-900"
                            >
                                Business Plan Information
                            </h3>
                            <p
                                class="max-w-2xl mt-1 text-sm leading-5 text-gray-500"
                            >
                                Personal details and status
                            </p>
                        </div>
                        <div class="px-4 py-5 sm:p-0">
                            <dl>
                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5"
                                >
                                    <dt
                                        class="text-sm font-medium leading-5 text-gray-500"
                                    >
                                        Nom
                                    </dt>
                                    <dd
                                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                                    >
                                        {{ info.data.user.name }}
                                    </dd>
                                </div>
                                <div
                                    class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                                >
                                    <dt
                                        class="text-sm font-medium leading-5 text-gray-500"
                                    >
                                        Cin
                                    </dt>
                                    <dd
                                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                                    >
                                        {{ info.data.user.cin }}
                                    </dd>
                                </div>
                                <div
                                    class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                                >
                                    <dt
                                        class="text-sm font-medium leading-5 text-gray-500"
                                    >
                                        Nom de entreprise
                                    </dt>
                                    <dd
                                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                                    >
                                        {{ info.data.entreprise_info.name }}
                                    </dd>
                                </div>
                                <div
                                    class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                                >
                                    <dt
                                        class="text-sm font-medium leading-5 text-gray-500"
                                    >
                                        Status
                                    </dt>
                                    <dd
                                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                                    >
                                        <span
                                            class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full "
                                            :class="{
                                                'bg-green-100 text-green-800':
                                                    info.outPut.status ===
                                                    'Succès',
                                                'bg-red-100 text-red-800':
                                                    info.outPut.status ===
                                                    'Danger',
                                                'bg-yellow-100 text-yellow-800':
                                                    info.outPut.status ===
                                                    'Avertissement'
                                            }"
                                        >
                                            {{ info.outPut.status }}
                                        </span>
                                    </dd>
                                </div>
                                <div
                                    class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                                >
                                    <dt
                                        class="text-sm font-medium leading-5 text-gray-500"
                                    >
                                        Message
                                    </dt>
                                    <dd
                                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                                    >
                                        <span>{{ message(info.data) }}</span>
                                        <span>{{
                                            subMessage(info.outPut)
                                        }}</span>
                                    </dd>
                                </div>
                                <div
                                    class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
                                >
                                    <dt
                                        class="text-sm font-medium leading-5 text-gray-500"
                                    >
                                        Attachments
                                    </dt>
                                    <dd
                                        class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                                    >
                                        <ul
                                            class="border border-gray-200 rounded-md"
                                        >
                                            <li
                                                class="flex items-center justify-between py-3 pl-3 pr-4 text-sm leading-5"
                                            >
                                                <div
                                                    class="flex items-center flex-1 w-0"
                                                >
                                                    <svg
                                                        class="flex-shrink-0 w-5 h-5 text-gray-400"
                                                        fill="currentColor"
                                                        viewBox="0 0 20 20"
                                                    >
                                                        <path
                                                            fill-rule="evenodd"
                                                            d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                                            clip-rule="evenodd"
                                                        />
                                                    </svg>
                                                    <span
                                                        class="flex-1 w-0 ml-2 truncate"
                                                    >
                                                        {{
                                                            info.data
                                                                .entreprise_info
                                                                .name
                                                        }}.pdf
                                                    </span>
                                                </div>
                                                <div class="flex space-x-5">
                                                    <div
                                                        class="flex-shrink-0 ml-4"
                                                    >
                                                        <!-- @click="downloadBpi" -->
                                                        <a
                                                            :href="
                                                                `/output?uid=${info.id}`
                                                            "
                                                            target="_blank"
                                                            class="font-medium text-blue-600 transition duration-150 ease-in-out cursor-pointer hover:text-blue-500"
                                                        >
                                                            Voir
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <a
                                                            class="font-medium text-blue-600 transition duration-150 ease-in-out cursor-pointer hover:text-blue-500"
                                                            target="_blank"
                                                            :href="
                                                                `/business_plan/${info.id}/vous_et_votre_projet/profils_des_investisseurs`
                                                            "
                                                            >Modifier</a
                                                        >
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
                <div class="mt-5 sm:mt-6">
                    <span class="flex w-2/4 mx-auto rounded-md shadow-sm">
                        <button
                            @click="$emit('modal-close')"
                            type="button"
                            class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                        >
                            Go back to dashboard
                        </button>
                    </span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import NProgress from "nprogress";

export default {
    props: {
        open: {
            type: Boolean,
            required: true
        },
        info: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {};
    },
    created() {
        const escapeHandler = e => {
            if (e.key === "Escape" && this.open) this.close();
        };
        document.addEventListener("keydown", escapeHandler);
        this.$once("hook:destroyed", () => {
            document.removeEventListener("keydown", escapeHandler);
        });
    },
    methods: {
        downloadBpi() {
            NProgress.start();
            this.$store
                .dispatch("user/downloadBpi", {
                    uid: this.info.id,
                    fileName: this.info.data.entreprise_info.name
                })
                .then(() => {
                    NProgress.done();
                })
                .catch(() => {});
        }
    },
    computed: {
        message() {
            return bpi => {
                const total =
                    bpi.investors_programme.nonValueAssetTotal +
                    bpi.investors_programme.intangibleAssetsTotal +
                    bpi.investors_programme.tangibleAssetsTotal +
                    bpi.investors_programme.diversImprevue;
                if (total !== bpi.investors_programme.capital)
                    return "les montants totaux deu PI et PF sont différents";
                return "";
            };
        },
        subMessage() {
            return bpi => {
                const index = bpi.cpc.findIndex(
                    element => element.resultatNet <= 0
                );
                if (index !== -1)
                    return `Votre entreprise n’est pas rentable l’année ${new Date(
                        bpi.generatedDate.seconds * 1000
                    ).getFullYear() +
                        index} veuillez revoir votre étude financière`;
                if (bpi.van > 0)
                    return "Votre projet est rentable passez à l’action";
                if (bpi.van < 0)
                    return "Votre projet n’est pas rentable veuillez revoir vos études financière et technique";
                return "";
            };
        }
    }
};
</script>

<style></style>
